import Core from "@/modules/core/service/Core";
import SearchRequest from "@/modules/core/service/private/SearchRequest";

export default {
    byId (incidentId) {
        if (incidentId.length < 5) {
            return Promise.resolve();
        }

        const body = {
            start: 0,
            length: 1,
            filter: {
                field: "incidentIdQuery",
                value: incidentId,
            },
            sort: {
                column: "id",
                dir   : "DESC"
            }
        };

        return Core.method.post(SearchRequest.url("/incident"), body).then (hits => {
            if (hits.data && hits.data.length === 1) {
                return Promise.resolve(hits.data[0]);
            }

            return Promise.resolve();
        });
    }
}